import { render } from "./CourseCards.vue?vue&type=template&id=f2520914&scoped=true"
import script from "./CourseCards.vue?vue&type=script&lang=js"
export * from "./CourseCards.vue?vue&type=script&lang=js"

import "./CourseCards.vue?vue&type=style&index=0&id=f2520914&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2520914"]])

export default __exports__